import type { WelcomeOfferBannerType } from "~/core";

export const isWelcomeOfferBanner = (
  item: unknown,
): item is WelcomeOfferBannerType => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "welcome_offer_banner" &&
    "items" in item &&
    item.items !== null
  );
};
